module.exports = __webpack_public_path__ + "static/media/3S.9395e390.svg";